module.exports = {
      id: "prothomalo-trust-usage",
      viewBox: "0 0 260 65",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#prothomalo-trust",
      toString: function () {
        return this.url;
      }
    }